import { useContext, useEffect, useMemo, useRef } from 'react';

import { LayoutContext } from '@lcsc-ui/layouts/baseLayout/provider';

import { testExternal } from '@/utils/tools';

export default function ProductPDF({ data }) {
  const { resourceData } = useContext(LayoutContext);
  const { projectConfigVO } = resourceData;
  const pdfUrl =
    data?.productRecord?.fileTypeVOList &&
    data.productRecord.fileTypeVOList.filter((item) => item.fileType === 'pdf_property').length > 0 &&
    data.productRecord.fileTypeVOList.filter((item) => item.fileType === 'pdf_property')[0].detailVOList &&
    data.productRecord.fileTypeVOList.filter((item) => item.fileType === 'pdf_property')[0].detailVOList.length > 0 &&
    data.productRecord.fileTypeVOList.filter((item) => item.fileType === 'pdf_property')[0].detailVOList[0].fileUrl;
  const pdfUrlSign = data?.pdfFileDetailVO?.urlSign || '';
  const isSouGou = useRef(false);
  const url =
    (process.env.NEXT_PUBLIC_APP_ENV !== 'pro' ? 'https://uatlcsq-oss.szlcsc.com' : projectConfigVO.lcscAttaUrl) +
    pdfUrl +
    '#page=1&view=fitH'; // 浏览器预览数据手册地址

  const downLoadPdf = `${process.env.NEXT_PUBLIC_APP_ENV !== 'pro' ? 'https://uatlcsq-oss.szlcsc.com' : projectConfigVO.lcscAttaUrl}${pdfUrl}${pdfUrlSign}`;

  const pdfEl = useMemo(
    () => (
      <section
        id="dataSheetTabItem"
        className="w-[810px] pt-[20px] pb-[30px] pl-[20px] pr-[20px] mt-[20px] rounded-[20px] bg-white [content-visibility:auto] [contain-intrinsic-height:1093px]"
        data-spm="pdf"
      >
        <div className="flex justify-between">
          <h2 className="text-[18px] text-[#0B1832] font-bold text-center">数据手册PDF</h2>
          <div className="text-center text-[#0093E6] text-[14px] flex items-center">
            <a
              id="item_pdf"
              className="mr-[20px]"
              aria-label={`查看${data?.productRecord?.productModel}数据手册`}
              target="_blank"
              href={`${projectConfigVO.lcscItemUrl}/datasheet/${encodeURIComponent(encodeURIComponent(data?.productRecord?.productModel))}/${data?.productRecord?.productId}.html`}
              data-spm="fd"
            >
              放大查看
            </a>
            <a
              id="item-pdf-down"
              href={downLoadPdf}
              target="_blank"
              className="flex justify-center items-center text-[#69788A] text-[14px] hover:text-[#0093E6]"
              rel="nofollow"
              ignore-spm
            >
              下载PDF
            </a>
          </div>
        </div>
        {isSouGou.current ? (
          <embed id="myPdfIframeSougou" src={url} frameBorder="0" className="w-[100%] h-[1000px] mt-[16px]"></embed>
        ) : (
          <iframe
            id="myPdfIframe"
            src={url}
            frameBorder="0"
            loading="lazy"
            className="w-[100%] h-[1000px] mt-[16px]"
          ></iframe>
        )}
      </section>
    ),
    [downLoadPdf]
  );

  useEffect(() => {
    isSouGou.current = testExternal(/sogou/);
  }, []);

  return pdfUrl ? pdfEl : <></>;
}
